import { render } from "./EntitlementUpdateModal.vue?vue&type=template&id=265f55d1&scoped=true"
import script from "./EntitlementUpdateModal.vue?vue&type=script&lang=js"
export * from "./EntitlementUpdateModal.vue?vue&type=script&lang=js"

import "./EntitlementUpdateModal.vue?vue&type=style&index=0&id=265f55d1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265f55d1"]])

export default __exports__